import { createAction, props } from '@ngrx/store';

import { RationComponent } from '../shared/models/models';

export const loadRationComponentsRequest = createAction('[App] Load ration components request');

export const loadRationComponentsSuccess = createAction(
  '[App] Load ration components success',
  props<{ rationComponents: RationComponent[] }>(),
);
